import { getErrorMessage } from 'mobile_web/modules/platform'
import React from 'react'
import { Text } from '@mytours/components'

interface Props {
	error: Error
}

const ErrorMessageHandler: React.FC<Props> = props => {
	if (!props.error) {
		return null
	}

	return (
		<Text variant="inherit" className="error-occurred">
			{getErrorMessage(props.error)}
		</Text>
	)
}

export default ErrorMessageHandler
